// RatingDefinitionContent.tsx
import { Rate } from "antd";
import { RatingField } from "api/types/_ratingDefine";
import i18n from "i18n";
import React from "react";
import { Col, Label } from "reactstrap";

interface RatingDefinitionProps {
  data: RatingField[];
  formik: any;
}

const RatingDefinitionContent: React.FC<RatingDefinitionProps> = ({
  data,
  formik,
}) => {
  const getRatingValue = (key: string) => {
    return formik?.values?.ratings?.find((r: any) => r.key === key)?.value ?? 0;
  };

  const setRatingValue = (key: string, value: any) => {
    const updatedRatings = formik?.values?.ratings?.map((r: any) =>
      r.key === key ? { ...r, value } : r
    );
    formik.setFieldValue("ratings", updatedRatings);
  };

  const FormatRatingStar = ({ item }: { item: RatingField }) => {
    return (
      <Col xxl={12} key={item.key}>
        <div className="mb-3">
          <Label className="form-label">
            {i18n?.language === "en" ? item.label.en : item.label.ko}
            {item.required && <span className="text-danger"> *</span>}
          </Label>
          <div>
            <Rate
              onChange={(stars) => setRatingValue(item.key, stars)}
              value={getRatingValue(item.key)}
              allowClear={false}
            />
          </div>
        </div>
      </Col>
    );
  };

  const FormatRatingBoolean = ({ item }: { item: RatingField }) => {
    const currentValue = getRatingValue(item.key);
    return (
      <Col xxl={12} key={item.key}>
        <div className="mb-3">
          <Label className="form-label">
            {i18n?.language === "en" ? item.label.en : item.label.ko}
            {item.required && <span className="text-danger"> *</span>}
          </Label>
          <div className="d-flex justify-content-start align-items-center">
            {item.options?.map((opt, index) => {
              return (
                <div
                  className="d-flex justify-content-start align-items-center form-check me-3"
                  key={index}
                >
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name={item.key}
                    id={`${item.key}_${index}`}
                    value={String(opt.value)}
                    checked={currentValue === opt.value}
                    style={{ minWidth: "16px" }}
                    onChange={() => setRatingValue(item.key, opt.value)}
                  />
                  <label
                    className="form-check-label position-relative"
                    htmlFor={`${item.key}_${index}`}
                  >
                    {i18n?.language === "en" ? opt.label.en : opt.label.ko}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </Col>
    );
  };

  return (
    <div className="row">
      {data?.map((item: RatingField) => {
        if (item.type === "stars") {
          return <FormatRatingStar item={item} key={item.key} />;
        } else if (item.type === "boolean") {
          return <FormatRatingBoolean item={item} key={item.key} />;
        } else {
          return <></>;
        }
      })}
    </div>
  );
};

export default RatingDefinitionContent;
